import { Button } from '@mui/material';
import { useQuery } from 'react-query';
import { IBuild, IResponse } from '../../../models';
import { downloadSitePlan, getPersonBuilds } from '../../../fetch';
import { useContext, useMemo, useState } from 'react';
import { UserContext } from '../../../context';
import { useSnackbar } from 'notistack';
import { Link } from '../../../components';

export const SitePlanButton = () => {
  const { enqueueSnackbar } = useSnackbar();
  const { user } = useContext(UserContext);
  const [isDownloading, setDownloading] = useState(false);
  const personId = user?.externalUser?.personId;
  const { isLoading, data: builds } = useQuery<IResponse<IBuild[]>, Error>(
    ['siteplan-builds'],
    async () =>
      await getPersonBuilds(personId, {
        perPage: '2', // get enough records to determine if multiple builds exist
        buildHasSitePlan: true // filter for builds with site plans
      }),
    {
      enabled: !!personId
    }
  );
  const hasMultipleBuilds = useMemo(() => builds?.records?.length > 1, [builds]);
  return personId ? (
    <Button
      variant="contained"
      sx={{
        width: { xs: '100%', md: '250px' }
      }}
      component={hasMultipleBuilds ? Link : undefined}
      to={hasMultipleBuilds ? '/my-build?homeownerPortal=true' : undefined}
      type="white"
      onClick={
        hasMultipleBuilds
          ? undefined
          : async () => {
              try {
                setDownloading(true);
                await downloadSitePlan(builds?.records[0].buildId);
              } catch (error) {
                enqueueSnackbar('Failed to download contract', { variant: 'error' });
              } finally {
                setDownloading(false);
              }
            }
      }
      disabled={
        isLoading ||
        builds?.records?.length === 0 ||
        isDownloading ||
        // disable if there's only one build and it has no site plan file
        (builds?.records?.length === 1 && !builds?.records[0].hasSitePlanFile)
      }
    >
      Site Plan
    </Button>
  ) : null;
};
